import { Box } from '@mui/material';
import React from 'react';
import { useStyles } from './Header.styles';
export const Header = (props) => {
    const classes = useStyles();
    const styles = [
        classes.root,
        (props.fullwidth ? classes.fullwidth : classes.regular)
    ];
    return (React.createElement(Box, { component: "header", sx: styles }, props.children));
};
export default Header;
